/**
 * Mirrors `com.mvs.backend.core.meta.logic.MetaDataAttributeType` — an `AlphaBaseEnum`, which
 * `GET /mvsa/core/meta/byAlias/{alias}` serializes as its ORDINAL (`AlphaBaseEnum#toJson`,
 * `@JsonValue`), because `MetaDataController.getEntityByAlias` returns the `MetaDataEntity` graph
 * directly. Live tenantA capture (2026-09-24): `cr.Customer.id` → `0`, `tm.TicketData.4` → `2`,
 * an unclassified member (`activityContext`, an embedded type) → `null`.
 *
 * The member ORDER is the wire contract and must never change. Only the by-id endpoint
 * (`MetaDataMapper.toAttributeDto`) exposes the enum NAME as a string — see
 * `MetaDataAttributeKind` for the reader that tolerates both.
 */
export enum MetaDataAttributeTypeEnum {
    regular,
    extended_object,
    generic_type_attribute,
    generic_value,
}
